import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import ScrollToTop from './ScrollToTop';
// import LoadingScreen from './LoadingScreen';

const Layout = () => {
  return (
    <>
      {/* <LoadingScreen /> */}
      <ScrollToTop />
      <Header />
      <main id="smooth-wrapper">
        <div id="smooth-content">
          <Outlet />
          <Footer />
        </div>
      </main>
    </>
  );
};

export default Layout;
